<template>
  <div class="slider-core">
    <div class="arrow-icon-container">
      <img src="../../assets/icons/arrow-long-slider.svg" alt="">
    </div>
    <div class="main-content">
      <div class="logo-container">
        <img alt="" src="../../assets/logo/seu-logo-square.svg">
      </div>
      <div class="heading-3-large">{{ mainTitle }}</div>
      <div class="lead-1" v-html="mainDescription"></div>
    </div>
    <div class="arrow-icon-container arrow-bottom">
      <img src="../../assets/icons/arrow-long-slider.svg" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'SliderCore',
  props: {
    mainTitle: {
      type: String,
      required: true,
    },
    mainDescription: {
      type: String,
      required: true,
    },
  }

}
</script>

<style lang="scss">
@import "SliderCore.scss";
</style>
